export default `
  html {
      touch-action: manipulation;      
  }

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #546E7A; 
}
`;



// WEBPACK FOOTER //
// ./src/view/component/lib/react-numpad/styles/global-css.js